module.exports = function(app) {
	'use strict'
	app.directive('addPostToExchange',addPostToExchange);
	addPostToExchange.$inject=['$timeout','refreshtokenService','alertService','serverError','config','postDataService','getDataService', 'offlineError'];
	function addPostToExchange($timeout, refreshtokenService, alertService,serverError, config, postDataService, getDataService, offlineError) {
		return {
			restrict: 'E',
			template: require('./partial/addPostToExchange.html'),
			link: function(scope, ele, $attrs, ctrl) {
				scope.config = config;
				scope.sharedCategory = angular.copy(scope.config.shared_contents[scope.typeAddToExchange])
				scope.addPostToExchange = function(type,postId) {
					var arr = []
					for(var i = 0; i<scope.sharedCategory.length;i++) {
						if(scope.sharedCategory[i].checked && !scope.sharedCategory[i].disabled) {
							arr.push(scope.sharedCategory[i]['_id'])
						}
					}
					if(arr.length==0) {
						alertService('danger', 'Opps! ', 'Shared content is required!');
						return
					} else {
						var postData = {
							category: arr
						}
						var postFunction = function() {   
							postDataService.save({
							param1:'shared-contents',
							param2:scope.typeAddToExchange,
							param3:postId 
							},postData).$promise.then(function(postData){
							alertService('success','Success ', postData.message, 2000);
							$timeout(function() {
								scope.closeAddPostToExchangeModal()
							},0)
							}, function(error){
								if(!window.navigator.onLine) {
									offlineError()
									$rootScope.hasLoaded = true;
									alertService('danger','Opps! ', 'Please check your internet connection and try again.');
									return
								}
								if(error.status ==401) {
									var promise = refreshtokenService.getAccessToken();
									promise.then(
									function(answer) {
										if(answer==200) {   
										postFunction();
										}
									},
									function(error) {
										// report something
									},
									function(progress) {
										// report progress
									});
								}else if(error.status ==502) {
									serverError();
								} else {
								alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
								}
							});
						}
						postFunction();
					}
				}
				var getCurrentCategory = function() {
					scope.loaded = false;
					getDataService.get({param1:'shared-contents', param2: scope.typeAddToExchange, param3:scope.typeAddToExchangePostId}).$promise.then(function(data){  
						scope.loaded = true;
						if(data.category && data.category.length>0) {
								for(var i=0; i<data.category.length;i++) {
								  for(var item = 0; item<scope.sharedCategory.length;item++) {
									  if(data.category[i] == scope.sharedCategory[item]['_id']) {
										  scope.sharedCategory[item].disabled= true;
										  scope.sharedCategory[item].checked= true;
									  }
								  }
							  }
							   
						}
						
					}, function(error){
						if(!window.navigator.onLine) {
							offlineError()
							return
						}
					  	if(error.status ==401) {
							var promise = refreshtokenService.getAccessToken();
							promise.then(
							function(answer) {
								if(answer==200) {
									getCurrentCategory()
								}
							},
							function(error) {
							},
							function(progress) {
							// report progress
							});
						} else if(error.status ==502) {
							serverError()
						} else {
							alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
						}
					  
					});
				}
				getCurrentCategory()
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/addPostToExchange/addPostToExchangeDirective.js
// module id = 431
// module chunks = 0